<template>
  <div class="productQuotationApplicationAdd container">
    <div class="searchBox">
      <div>
        <el-button size="mini" class="btn" type="primary" v-acl="ProApplySupSave" v-show="saveBtnShow" @click="saveQuotationApply">保存</el-button>
        <el-button size="mini" class="btn" type="primary" v-acl="ProApplySupSave" v-show="submitBtnShow" @click="submitQuotationApply">提交</el-button>
        <el-button size="mini" class="btn" type="primary" @click="historyBack">{{$t('common.close')}}</el-button>
        <!--关闭-->
      </div>
      <el-form label-width="120px" ref="applyInfoForm" :model="searchForm" label-position="right" class="topform">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="单据编号">
              <el-input class="handle-input" v-model="searchForm.applyNo" disabled style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="主题">
              <el-input class="handle-input" v-model="searchForm.subject" :disabled="!saveBtnShow" clearable placeholder="请输入主题" maxlength="300" style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="类型">
              <el-select class="handle-input" v-model="searchForm.applyType" :disabled="true" style="width:100%">
                <el-option :key="index" v-for="(item,index) in applyTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="创建人">
              <el-input class="handle-input" v-model="searchForm.name" disabled style="width:100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="创建日期">
              <el-date-picker value-format="yyyy-MM-dd" class="handle-input" type="date" v-model="searchForm.createDate" placeholder="选择日期" disabled style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="产品报价明细" name="first">
        <div class="toolsBox">
          <el-button class="btn" v-show="!disableEditor" type="primary" v-acl="ProApplySupSave" @click="showApplyLineAddDialogFunc()" size="mini">新增</el-button>
          <el-button class="btn" v-show="!disableEditor" type="danger" v-acl="ProApplySupSave" @click="delSelQuotationApplyLine()" size="mini">删除</el-button>
          <el-button size="mini" class="btn" type="primary" @click="onExport">{{$t('common.export')}}</el-button>
        </div>
        <ux-grid ref="applyProductTableDataRef" data="applyProductTableData" highlight-current-row max-height="550" show-overflow="tooltip">
          <ux-table-column align="center" type="checkbox" width="80" />
          <ux-table-column align="center" title="操作" min-width="80" v-show="!disableEditor">
            <template v-slot="scope">
              <i class="el-icon-edit-outline" @click="onEdit(scope)"></i>
            </template>
          </ux-table-column>
          <ux-table-column align="center" title="序号" type="index" width="60"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="8位码" field="eightBitCode" min-width="140"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="8位码名称" field="eightBitCodeName" min-width="200px"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="提货点" field="pickupPoint" min-width="80"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="到货仓库（DC）" field="dcName" min-width="120px"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="运输方式" field="transportaionMethod" min-width="140">
            <template v-slot="scope">
              {{scope.row.transportaionMethod | ic("COMMON",'TRANSPORTAION_METHOD')}}
            </template>
          </ux-table-column>
          <ux-table-column align="center" sortable resizable title="温区" field="temperatureI18n" min-width="70"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="产品有效开始日期" field="effectiveBeginDate" min-width="150"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="入围供应商" field="supplierNames" min-width="120px"></ux-table-column>
        </ux-grid>
      </el-tab-pane>
    </el-tabs>

    <el-dialog el-dialog title="8位码选择" :visible.sync="dialogVisible" width="80%">
      <el-form :model="materialSearchForm" label-width="120px" inline>
        <el-form-item label="8位码编号:" size="small">
          <el-input v-model="materialSearchForm.eightBitCode" clearable />
        </el-form-item>
        <el-form-item label="8位码名称:" size="small">
          <el-input v-model="materialSearchForm.eightBitCodeName" clearable />
        </el-form-item>
        <el-form-item label="工厂编号:" size="small">
          <el-input v-model="materialSearchForm.plantNo" clearable />
        </el-form-item>
        <el-form-item label="工厂名称:" size="small">
          <el-input v-model="materialSearchForm.plantName" clearable />
        </el-form-item>
        <el-form-item label="供应商编号:" size="small">
          <el-input v-model="materialSearchForm.supplierCode" clearable />
        </el-form-item>
        <el-form-item label="供应商名称:" size="small">
          <el-input v-model="materialSearchForm.supplierName" clearable />
        </el-form-item>
        <el-form-item label="提货点:" size="small">
          <el-input v-model="materialSearchForm.pickupPoint" clearable />
        </el-form-item>
        <el-form-item label="DC:" size="small">
          <el-input v-model="materialSearchForm.dcName" clearable />
        </el-form-item>
        <el-form-item label="温区:" size="small">
          <el-input v-model="materialSearchForm.temperature" clearable />
        </el-form-item>
        <el-form-item label="运输方式:" size="small">
          <el-input v-model="materialSearchForm.transportaionMethod" clearable />
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="primary" @click="fatchMaterial()">查询</el-button>
        </el-form-item>
      </el-form>
      <div style="margin-bottom:10px;">
        <el-button type="primary" @click="createDetailMateria()">选择</el-button>
      </div>
      <el-table :data="materialList" border highlight-current-row class="dialogIntable" @selection-change="handleSelectionChangeMateria">
        <el-table-column type="selection" min-width="55"></el-table-column>
        <el-table-column show-overflow-tooltip prop="eightBitCode" sortable label="8位码"></el-table-column>
        <el-table-column show-overflow-tooltip prop="eightBitCodeName" sortable label="8位码名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="plantName" sortable label="对应工厂编号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierCode" sortable label="供应商编号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierName" sortable label="供应商名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="dcName" sortable label="DC"></el-table-column>
        <el-table-column show-overflow-tooltip prop="temperatureI18n" sortable label="温区"></el-table-column>
        <el-table-column show-overflow-tooltip prop="transportaionMethodI18n" sortable label="运输方式"></el-table-column>
      </el-table>
    </el-dialog>
    <!-- 到货仓库 -->
    <el-dialog :visible.sync="showSelDcMultipleDialog" append-to-body width="80%">
      <SelDc ref="selectDcMultipleRef" :multipleSelectionFlag="false" @subCallMethod="selectDcMethod"></SelDc>
    </el-dialog>
    <!--提货点选择-->
    <el-dialog :visible.sync="showSelPickupPointDialog" append-to-body width="80%">
      <SelPickupPoint ref="selPickupPointRef" @subCallMethod="selectPickupPointMethod"></SelPickupPoint>
    </el-dialog>
    <el-dialog title="报价明细" :visible.sync="dialogEditVisible" width="80%" @close="onCancel">
      <el-table :data="tableData" ref="tableDataRef" border highlight-current-row max-height="470">
        <el-table-column sortable prop="eightBitCode" label="8位码" width="140">
          <template slot-scope="scope">
            <el-input :disabled="disableEditor" v-model="scope.row.eightBitCode" @blur="checkEightBitCode(scope.row.eightBitCode,scope.row)">&nbsp;</el-input>
          </template>
        </el-table-column>
        <el-table-column sortable prop="eightBitCodeName" label="8位码名称" width="200px"></el-table-column>
        <el-table-column sortable prop="pickupPoint" label="提货点" width="80">
          <template slot-scope="scope">
            <el-input :disabled="disableEditor" @focus="showSelPickupPointDialogFunc(scope.row)" suffix-icon="el-icon-search" v-model="scope.row.pickupPoint"></el-input>
          </template>
        </el-table-column>
        <el-table-column sortable prop="dcName" label="到货仓库（DC）">
          <template slot-scope="scope">
            <el-input :disabled="disableEditor" @click.native="showSelDcDialogFunc('1',scope.row)" suffix-icon="el-icon-search" v-model="scope.row.dcName">&nbsp;</el-input>
          </template>
        </el-table-column>
        <el-table-column sortable prop="transportaionMethod" label="运输方式" width="140">
          <template slot-scope="scope">
            <el-select :disabled="disableEditor" v-model="scope.row.transportaionMethod" class="handle-input">
              <el-option :key="index" v-for="(item,index) in transportaionMethodList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column sortable prop="temperatureI18n" label="温区" width="70"></el-table-column>
        <el-table-column sortable prop="effectiveBeginDate" label="产品有效开始日期" width="150">
          <template slot-scope="scope">
            <el-date-picker :picker-options="searchForm.applyType==4?pickerOptions:null" :disabled="disableEditor" style="width: 100%" value-format="yyyy-MM-dd" v-model="scope.row.effectiveBeginDate" type="date" :placeholder="$t('common.selDate')"></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column sortable prop="supplierNames" label="入围供应商">
          <template slot-scope="scope">
            <el-input :disabled="true" v-model="scope.row.supplierNames">&nbsp;</el-input>
          </template>
        </el-table-column>
      </el-table>
      <el-row type="flex" justify="center" style="margin-top:10px;">
        <el-button type="primary" @click="onConfirm">确认</el-button>
        <el-button type="primary" @click="onCancel">取消</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import {
  getQuotationApplyInfo,
  getMaterial,
  createDetail,
  submitApplyInfo,
  delSelQuotationApplyPro,
  createApplyInfo
} from "@/api/quoteByProduct.js";

import {
  supSave, eightBitCode
} from "@/api/quoteByProductSup.js";
import { applyService } from "../../../../api/quotation-apply-sup/quotation-apply";
import SelPickupPoint from '@/components/page/base-data/pickup-point-sel'
import { inputChoiceService } from "@/api/common/input-choice";
import SelDc from "@/components/page/base-data/dc-sel-page";
import SelSupplier from "@/components/page/base-data/carrier-sel-page";
import { fileService } from "@/api/common/file-utils";
import commonFun from "@/utils/commonFun";
import commonConstants from "@/constants/commonConstants";
let minDate = new Date();
if (minDate.getMonth() >= 10) {
  minDate.setFullYear(minDate.getFullYear() + 1);
  minDate.setMonth(minDate.getMonth() + 1 - 12);
} else {
  minDate.setMonth(minDate.getMonth() + 1);
}
minDate.setDate(1);
export default {
  name: "productQuotationApplicationAdd",
  components: {
    SelSupplier,
    SelPickupPoint,
    SelDc
  },
  computed: {
    importDetailUrl() {
      return commonConstants.baseUrl + `apply/importDetail/${this.ttQuotationApplyId}`;
    },
    headers() {
      return {
        "x-access-token": localStorage.getItem('token')
      }
    }
  },
  data() {
    return {
      dialogEditVisible: false,
      tableData: [],
      index: null,
      tempRows: null,
      activeName: 'first',
      ttQuotationApplyId: null,
      submitBtnShow: false,
      saveBtnShow: false,
      disableEditor: true,
      showSelDcMultipleDialog: false,
      showSelPickupPointDialog: false,
      showUploadFlag: false,
      searchForm: {},
      materialSearchForm: {
        eightBitCode: "",
        eightBitCodeName: "",
        plantName: "",
        supplierCode: "",
        supplierName: "",
        pickupPoint: "",
        dcName: "",
        temperature: "",
        transportaionMethod: ""
      },
      transportaionMethodList: [],
      applyProductTableData: [],
      fileList: [],
      materialList: [],
      applyTypeList: [],
      dialogVisible: false,
      SelectionChangeMateriaObj: [],
      page: {
        size: 10,
        current: 1,
        total: 0
      },
      supplierNames: '',
      pickerOptions: {
        defaultValue: minDate,
        disabledDate: function (date) {
          let now = new Date();
          if (now.getMonth() >= 10) {
            now.setFullYear(now.getFullYear() + 1);
            now.setMonth(now.getMonth() + 1 - 12);
          } else {
            now.setMonth(now.getMonth() + 1);
          }
          now.setDate(0);
          return date.getTime() >= now.getTime() ? false : true;
        },
      }
    };
  },
  created() {
    this.ttQuotationApplyId = this.$route.query.applyId;
    this.applyPageInit(this.$route.query.applyId);
    this.getInputChoiceValues();
    //this.getFiles();
  },
  methods: {
    applyPageInit: function (applyId) {
      getQuotationApplyInfo(applyId).then(res => {
        this.searchForm = res.quotationApply;
        this.supplierNames = res.quotationApply.supplierNames;
        if (res.quotationApplyProduct && res.quotationApplyProduct.length > 0) {
          this.applyProductTableData = res.quotationApplyProduct;
        }
        if (!!res.quotationApply.ttQuotationApplyId && res.quotationApply.status == '1' && res.quotationApply.source == 'SUP') {
          //草稿单据(并且来源(source)为供应商自己SUP)
          this.submitBtnShow = true;
          this.saveBtnShow = true;
          this.showUploadFlag = true;
          this.disableEditor = false;
          //如果是线路变更申请单
          if (res.quotationApply.applyType == '2') {
            this.applyLineEdit = false;
          }
        } else if (this.ttQuotationApplyId <= 0) {
          this.saveBtnShow = true;
          this.submitBtnShow = true;
          this.disableEditor = false;
        }
        this.$refs.applyProductTableDataRef.reloadData(res.quotationApplyProduct)
      });
    },
    onEdit(scope) {
      this.dialogEditVisible = true
      this.index = scope.rowIndex
      this.tableData.push(JSON.parse(JSON.stringify(scope.row)))
    },
    onConfirm() {
      this.$refs.applyProductTableDataRef.reloadRow(this.$refs.applyProductTableDataRef.data[this.index], this.tableData[0], null)
      this.dialogEditVisible = false
      setTimeout(() => {
        this.tableData = []
      }, 500);
    },
    onCancel() {
      this.dialogEditVisible = false
      this.tableData = []
    },
    onExport() {
      applyService.exportDetail(this.ttQuotationApplyId).then((res) => {
        fileService.respToFile(res, '产品报价申请单' + this.searchForm.applyNo + '.xlsx');
      })
    },
    checkEightBitCode: function (value, row) {
      if (value.length >= 1) {
        eightBitCode(value).then(res => {
          row.pickupPoint = res.pickupPoint
          row.temperatureI18n = res.temperatureI18n
          row.eightBitCodeName = res.eightBitCodeName
          row.eightBitCode = res.eightBitCode
        })
          .catch(() => {
            row.eightBitCode = ''
          });
        ;
      } else {
        row.pickupPoint = ''
        row.temperatureI18n = ''
      }
    },
    showSelPickupPointDialogFunc: function (row) {
      if (!!row) {
        this.tempRows = row;
      } else {
        this.tempRows = null;
      }
      this.showSelPickupPointDialog = true;
      if (this.$refs.selPickupPointRef != undefined) {
        this.$refs.selPickupPointRef.cancelSeleted();
      }
    },
    //提货点选择
    selectPickupPointMethod: function (pickupPoint) {
      if (!!this.tempRows) {
        this.tempRows.pickupPoint = pickupPoint.pickupPoint;
        this.tempRows.tmPickupId = pickupPoint.tmPickupPointId;
      } else {
        this.applyLineNew.pickupPoint = pickupPoint.pickupPoint;
        this.applyLineNew.tmPickupId = pickupPoint.tmPickupPointId;
      }
      this.showSelPickupPointDialog = false;
    },
    //报价保存
    saveQuotationApply: function () {
      var that = this;
      if (this.applyProductTableData != null) {
        if (this.applyProductTableData.length > 0) {
          let quotationApplyInfo = {};
          quotationApplyInfo.method = 'save'
          quotationApplyInfo.quotationApply = this.searchForm;
          quotationApplyInfo.quotationApplyProduct = this.applyProductTableData;
          //修改
          supSave(quotationApplyInfo).then(res => {
            if (res.meta.success) {
              that.ttQuotationApplyId = res.data;
              that.applyPageInit(res.data);
              that.$message({
                message: this.$t("common.saveSuccess"),
                type: "success"
              });
            }
          });
        }
      } else {
        //新增
        let quotationApplyInfo = {};
        quotationApplyInfo.method = 'save'
        quotationApplyInfo.quotationApply = this.searchForm;
        supSave(quotationApplyInfo).then(res => {
          if (res.meta.success) {
            this.ttQuotationApplyId = res.data;
            this.applyPageInit(res.data);
          }
        });
      }
    },
    //线路报价申请单提交
    submitQuotationApply: function () {
      let _this = this;
      if (!!this.ttQuotationApplyId) {
        //先判断DC和入围供应商是否为空
        let applyProductTableData = _this.applyProductTableData;
        for (var i = 0; i < applyProductTableData.length; i++) {
          if (
            applyProductTableData[i].eightBitCode == null ||
            applyProductTableData[i].eightBitCode == ""
          ) {
            _this.$message({ message: "8位码为必填", type: "warning" });
            return;
          }
          let item = applyProductTableData[i];
          if (commonFun.isEmpty(item.tmDcId)) {
            _this.$message({ message: "DC为必填", type: "warning" });
            return;
          }
          if (commonFun.isEmpty(item.supplierIds)) {
            _this.$message({ message: "入围供应商为必填", type: "warning" });
            return;
          }
          if (commonFun.isEmpty(item.tmPickupId)) {
            _this.$message({ message: "请选择提货点", type: "warning" });
            return;
          }
          if (commonFun.isEmpty(item.transportaionMethod)) {
            _this.$message({ message: "请选择运输方式", type: "warning" });
            return;
          }
          if (commonFun.isEmpty(item.effectiveBeginDate)) {
            _this.$message({ message: "产品有效开始日期不能为空", type: "warning" });
            return;
          }
        }
        _this.$confirm(this.$t("common.sureSubmit"), this.$t("common.tips"), {
          confirmButtonText: this.$t("common.confirm"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        })
          .then(() => {
            _this.submitBtnShow = false;
            let quotationApplyInfo = {};
            quotationApplyInfo.method = 'submit'
            quotationApplyInfo.quotationApply = this.searchForm;
            quotationApplyInfo.quotationApplyProduct = this.applyProductTableData;
            supSave(quotationApplyInfo)
              .then(res => {
                if (res.meta.success) {
                  _this.$message({
                    message: _this.$t("common.submitSuccess"),
                    type: "success"
                  });
                  _this.historyBack();
                } else {
                  _this
                    .$confirm(res.meta.msg, _this.$t("common.tips"), {
                      confirmButtonText: _this.$t("common.confirm"),
                      cancelButtonText: _this.$t("common.cancel"),
                      type: "warning"
                    })
                    .then(() => {
                      //用户确认后再次提交
                      quotationApplyInfo.confirm = 1;
                      supSave(quotationApplyInfo)
                        .then(res => {
                          _this.$message({
                            message: _this.$t("common.submitSuccess"),
                            type: "success"
                          });
                          _this.historyBack();
                        })
                        .catch(() => {
                        });
                    })
                }
              })
          })
          .catch(() => {
          });

      }
    },
    //下拉列表数据获取
    getInputChoiceValues: function () {
      let mapObj = {};
      mapObj["TT_QUOTATION_APPLY:PRODUCT_APPLY_TYPE"] =
        "TT_QUOTATION_APPLY:PRODUCT_APPLY_TYPE";
      mapObj["COMMON:TRANSPORTAION_METHOD"] = "COMMON:TRANSPORTAION_METHOD";
      inputChoiceService.getInputChoiceValues(mapObj).then(res => {
        this.applyTypeList = res["TT_QUOTATION_APPLY:PRODUCT_APPLY_TYPE"];
        this.transportaionMethodList = res["COMMON:TRANSPORTAION_METHOD"];
      });
    },
    showApplyLineAddDialogFunc() {
      if (!this.disableEditor) {
        var list = {
          eightBitCode: '',
          pickupPoint: '',
          dcName: '',
          transportaionMethod: '',
          temperatureI18n: '',
          effectiveBeginDate: '',
          supplierNames: this.supplierNames
        }
        if (this.applyProductTableData == null) {
          this.applyProductTableData = []
          this.applyProductTableData.push(list)
        } else {
          this.applyProductTableData.push(list)
        }
      }

    },
    //查询8位码
    fatchMaterial() {
      let that = this;
      let data = {
        eightBitCode: this.materialSearchForm.eightBitCode,
        eightBitCodeName: this.materialSearchForm.eightBitCodeName,
        plantName: this.materialSearchForm.plantName,
        supplierCode: this.materialSearchForm.supplierCode,
        supplierName: this.materialSearchForm.supplierName,
        pickupPoint: this.materialSearchForm.pickupPoint,
        dcName: this.materialSearchForm.dcName,
        temperature: this.materialSearchForm.temperature,
        transportaionMethod: this.materialSearchForm.transportaionMethod,
        pageSize: that.page.size,
        pageNum: that.page.current
      };
      getMaterial(data).then(res => {
        that.materialList = res.resultData;
        this.page.total = res.totalCount;
      });
    },
    //选择好 8位码（明细创建）
    createDetailMateria() {
      let that = this;
      let datas = this.SelectionChangeMateriaObj;
      var data = datas.map(function (item) {
        let obj = {
          tmMaterialId: item["tmMaterialId"],
          tmDcId: item["tmDcId"],
          tmPickupId: item["tmPickupId"],
          temperature: item["temperature"],
          eightBitCode: item["eightBitCode"]
        };
        return obj;
      });
      createDetail(that.ttQuotationApplyId, data).then(res => {
        that.dialogVisible = false;
        that.applyPageInit(that.ttQuotationApplyId);
      });
    },

    showSelDcDialogFunc: function (method, row) {
      let that = this;
      if (!!row) {
        this.tempRows = row;
      } else {
        this.tempRows = null;
      }
      if ("1" == method) {
        if (!that.disableEditor) {
          //单选
          this.multipleSelectionBl = false;
          this.showSelDcMultipleDialog = true;
        }
        this.$refs.selectDcMultipleRef.cancelSeleted();
      } else {
        this.multipleSelectionBl = true;
        this.showSelDcDialog = true;
      }
    },
    showSelSupplierFunc: function (row) {
      let that = this;
      if (!that.disableEditor) {
        this.showSelSupplierDialog = true;
        if (!!row) {
          this.tempRows2 = row;
        } else {
          this.tempRows2 = null;
        }
      }
    },
    //到货仓库选择
    selectDcMethod: function (dcList) {
      let _this = this;
      if (this.multipleSelectionBl) {
        //多选
        let codes = new Array();
        let dcIds = new Array();
        dcList.forEach(item => {
          dcIds.push(item.tmDcId);
          codes.push(item.dcName);
        });
        _this.applyLineNew.dcName = codes.join(",");
        _this.applyLineNew.dcIds = dcIds;
      } else {
        //单选
        this.tempRows.tmDcId = dcList[0].tmDcId;
        this.tempRows.dcName = dcList[0].dcName;
      }
      this.showSelDcDialog = false;
      this.showSelDcMultipleDialog = false;
    },
    //供应商选择
    selectSupplierMethod: function (supList) {
      let _this = this;
      let codes = new Array();
      let supplierIds = [];
      supList.forEach(item => {
        supplierIds.push(item.tmSupplierId);
        codes.push(item.supplierCode);
      });
      _this.tempRows2.supplierNames = codes.join(",");
      _this.tempRows2.supplierIds = supplierIds;
      // _this.applyData.supplierCodes = codes.join(",");
      // _this.applyData.supplierIds = _this.supplierIds;
      this.showSelSupplierDialog = false;
    },
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFile(row).then((res) => {
      })
    },
    //文件删除
    deleteFile: function (tmDocumentId, index, files) {
      fileService.deleteFile(tmDocumentId).then((res) => {
        //删除成功删除列表数据
        files.splice(index, 1);
      })
    },
    //文件列表数据获取
    getFiles: function () {
      let attachment = {};
      attachment.seq = '1';
      attachment.tsRecId = this.ttQuotationApplyId;
      attachment.tsReckindId = 'QUOTATION_APPLY';
      fileService.getFileList(attachment).then((fileRes) => {
        this.fileList = fileRes;
      })
    },
    //文件上传
    uploadConfirm: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then((res) => {
        //调用成功后调用后台方法进行文件关系维护
        let attachment = {};
        attachment.documents = res.data;
        attachment.seq = '1';
        attachment.tsRecId = this.ttQuotationApplyId;
        attachment.tsReckindId = 'QUOTATION_APPLY';
        fileService.saveFile(attachment).then((saveRes) => {
          _this.getFiles();
        })
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    handleSizeChange(e) {
      this.page.size = e;
      // this.customer_list();
    },
    handleCurrentChange(e) {
      this.page.current = e;
      //  this.customer_list();
    },
    handleSelectionChange(row) {
      console.log(row);
    },
    handleSelectionChangeMateria(val) {
      this.SelectionChangeMateriaObj = val;
      console.log(this.SelectionChangeMateriaObj);
    },
    delSelQuotationApplyLine() {
      var that = this;
      let rows = this.$refs.applyProductTableDataRef.getCheckboxRecords();
      if (rows.length == 0) {
        //请选择需要删除的明细
        that.$message({
          message: that.$t("apply.selectDelLine"),
          type: "warning"
        });
      } else {
        let ids = [];
        rows.forEach(item => {
          if (item.ttQuotationApplyProductId) {
            ids.push(item.ttQuotationApplyProductId);
          }
        });
        let tableDate = this.$refs.applyProductTableDataRef.data;
        if (ids.length > 0) {
          delSelQuotationApplyPro(ids).then(res => {
            if (res.meta.success) {
              that.$message({
                message: that.$t("common.delSuccess"),
                type: "success"
              });
              rows.forEach(item => {
                tableDate.splice(tableDate.indexOf(item), 1);
              });
            } else {
              that.$message({
                message: that.$t("common.delError"),
                type: "error"
              });
            }
          });
        } else {
          rows.forEach(item => {
            tableDate.splice(tableDate.indexOf(item), 1);
          });
        }

      }
    },
    historyBack() {
      switch (this.$route.query.source) {
        case 'productFreight':
          this.$router.push({ path: '/materialPriceData' });
          break;
        default:
          this.$router.go(-1);
      }
    }
  },
};
</script>
<style scoped lang="scss">
.handle-input {
  width: 99%;
}

.productQuotationApplicationAdd {
  .toolsBox {
    margin-bottom: 5px;
  }
  .a-link {
    text-decoration: underline;
  }
  .topform {
    margin-top: 20px;
  }
}
</style>
